import { motion } from "framer-motion";
import { Star, ExternalLink, Quote } from "lucide-react";

const GOOGLE_URL =
  "https://www.google.com/maps/place/Escarg'Holala/@46.6914017,4.6028623,17z/data=!3m1!4b1!4m6!3m5!1s0x47f3ab9848fdb099:0xaecd67b5b5c9f50d!8m2!3d46.6914017!4d4.6054372!16s%2Fg%2F11t3c3xttm";

const AMBIANCE =
  "https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/prz8sfsa_image.png";

const avis = [
  {
    texte:
      "Un régal ce moment auprès de Béatrice et de ces milliers d'escargots ! Des explications passionnées, dans un lieu très charmant. Une dégustation avec des produits « fait maison ». Un arrêt à programmer ! Merci beaucoup Béatrice. Des motards de Brèles Balades !",
    auteur: "Marine Taboulot",
    date: "Visité en juin",
  },
  {
    texte:
      "Nous étions en vacances dans le coin. Nous avons fait une très belle et bonne découverte. 🐌 Visite et dégustation au TOP. Les escargots sont élevés et préparés avec soin et goût ! Ils sont extra ! 🐌",
    auteur: "Florence Bergaire",
    date: "Local Guide · Visité en août 2025",
  },
];

const Avis = () => {
  return (
    <section data-testid="avis-section" id="avis" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Ils nous ont rendu visite</span>
          <h2 className="font-heading text-4xl sm:text-5xl text-foreground mt-2 tracking-tight">
            La confiance de nos hôtes
          </h2>
          <div className="flex items-center justify-center gap-1.5 mt-6" data-testid="avis-stars">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={26} className="fill-[#E3A008] text-[#E3A008]" />
            ))}
          </div>
          <div className="mt-3 flex items-baseline justify-center gap-2">
            <span className="font-heading text-5xl text-bordeaux" data-testid="avis-note">4,9</span>
            <span className="font-heading text-xl text-foreground/50">/ 5 sur Google</span>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mt-14 items-stretch">
          {avis.map((a, i) => (
            <motion.figure
              key={a.auteur}
              data-testid={`avis-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative bg-creme rounded-[2rem] p-8 lg:p-10 border border-border shadow-[0_12px_40px_rgba(44,42,40,0.08)] flex flex-col"
            >
              <Quote size={40} className="text-bordeaux/25 absolute top-6 right-8" />
              <div className="flex gap-1 mb-4">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={18} className="fill-[#E3A008] text-[#E3A008]" />
                ))}
              </div>
              <blockquote className="font-heading text-xl sm:text-2xl text-foreground leading-relaxed italic flex-1">
                « {a.texte} »
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-border">
                <div className="font-600 text-bordeaux">{a.auteur}</div>
                <div className="text-sm text-foreground/55">{a.date}</div>
              </figcaption>
            </motion.figure>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="rounded-[2rem] overflow-hidden shadow-[0_12px_40px_rgba(44,42,40,0.12)] min-h-[300px]"
          >
            <img src={AMBIANCE} alt="Produits Escarg'Holala en Sud Côte Chalonnaise" className="w-full h-full object-cover" />
          </motion.div>
        </div>

        <div className="text-center mt-12">
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="avis-google-btn"
            className="inline-flex items-center gap-2 rounded-full bg-bordeaux text-white font-600 px-7 py-3.5 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5"
          >
            Voir tous nos avis sur Google <ExternalLink size={17} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Avis;
